<script setup>
import { computed } from 'vue';
import AppSearch from '@/components/app/search/index.vue';
import AppIcon from '@/components/utility/icons/index.vue';
import UserDropdown from './UserDropdown.vue';
import { useAppStore } from '@/store/app/app.js';

const appStore = useAppStore();
const showSearch = computed(
  () => !appStore.state?.uixpress_settings?.disable_search
);
</script>

<template>
  <div
    id="uixpress-frontend-minimal"
    class="uixpress-frontend-minimal uipx-normalize uixpress-isolation"
  >
    <AppSearch v-if="showSearch">
      <template #trigger="{ openModal }">
        <button
          id="uixp-frontend-search-trigger"
          type="button"
          aria-label="Open search"
          @click.prevent="openModal"
        >
          <AppIcon
            icon="search"
            class="text-zinc-300 hover:text-zinc-100 text-[17px]"
          />
        </button>
      </template>
    </AppSearch>
    <UserDropdown />
  </div>
</template>

<style scoped>
:deep(#wpadminbar #wp-admin-bar-uixpress-frontend-toolbar-app > .ab-item) {
  padding: 0 !important;
  margin: 0 !important;
  height: 32px !important;
  line-height: 32px !important;
  background: transparent !important;
}

:deep(
    #wpadminbar #wp-admin-bar-uixpress-frontend-toolbar-app:hover > .ab-item
  ) {
  background: transparent !important;
}

:deep(
    #wpadminbar
      #wp-admin-bar-uixpress-frontend-toolbar-app
      #uixpress-frontend-app
  ) {
  height: 32px !important;
  display: flex !important;
  align-items: center !important;
}

#uixpress-frontend-minimal {
  height: 32px;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Prevent WP/theme admin-bar styles from leaking into mounted controls */
:deep(
    #wpadminbar
      #wp-admin-bar-uixpress-frontend-toolbar-app
      #uixpress-frontend-minimal
      *
  ),
:deep(
    #wpadminbar
      #wp-admin-bar-uixpress-frontend-toolbar-app
      #uixpress-frontend-minimal
      *::before
  ),
:deep(
    #wpadminbar
      #wp-admin-bar-uixpress-frontend-toolbar-app
      #uixpress-frontend-minimal
      *::after
  ) {
  box-sizing: border-box !important;
}

:deep(
    #wpadminbar
      #wp-admin-bar-uixpress-frontend-toolbar-app
      #uixp-frontend-search-trigger
  ) {
  appearance: none !important;
  -webkit-appearance: none !important;
  border: 0 !important;
  outline: none !important;
  box-shadow: none !important;
  background: transparent !important;
  color: #f9fafb !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  vertical-align: middle !important;
  width: 28px !important;
  min-width: 28px !important;
  height: 28px !important;
  min-height: 28px !important;
  padding: 4px !important;
  border-radius: 6px !important;
  margin: 0 !important;
  line-height: 1 !important;
}

:deep(
    #wpadminbar
      #wp-admin-bar-uixpress-frontend-toolbar-app
      #uixp-frontend-search-trigger::before
  ),
:deep(
    #wpadminbar
      #wp-admin-bar-uixpress-frontend-toolbar-app
      #uixp-frontend-search-trigger::after
  ) {
  content: none !important;
}

:deep(
    #wpadminbar
      #wp-admin-bar-uixpress-frontend-toolbar-app
      #uixp-frontend-search-trigger
  ) {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 28px !important;
  height: 28px !important;
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1 !important;
}

:deep(
    #wpadminbar
      #wp-admin-bar-uixpress-frontend-toolbar-app
      #uixp-frontend-search-trigger
      span
  ) {
  width: 16px !important;
  height: 16px !important;
  min-width: 16px !important;
  min-height: 16px !important;
  display: inline-block !important;
  line-height: 16px !important;
}

@media screen and (max-width: 782px) {
  :deep(#wpadminbar #wp-admin-bar-uixpress-frontend-toolbar-app > .ab-item) {
    height: 46px !important;
    line-height: 46px !important;
  }

  :deep(
      #wpadminbar
        #wp-admin-bar-uixpress-frontend-toolbar-app
        #uixpress-frontend-app
    ) {
    height: 46px !important;
  }

  #uixpress-frontend-minimal {
    height: 46px;
  }
}
</style>

<style>
@reference "tailwindcss";
#wp-admin-bar-my-account,
#wp-admin-bar-search,
#wp-admin-bar-wp-logo {
  display: none !important;
}

#wpadminbar {
  @apply bg-zinc-950;
}
</style>
